import { render, staticRenderFns } from "./EmailButton.vue?vue&type=template&id=2194f8aa"
import script from "./EmailButton.vue?vue&type=script&lang=js"
export * from "./EmailButton.vue?vue&type=script&lang=js"
import style0 from "./EmailButton.vue?vue&type=style&index=0&id=2194f8aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports